<template>
  <div id="index">
    <div v-if="!is_loading">
      <div class="spinner-box">
        <img src="@/assets/img/loadding_pc.gif" alt="">
        <div>努力加载中...</div>
      </div>
    </div>
    <div v-show="is_loading">
      <!-- 头部 -->
      <HeaderTop :headIndex="4" ref="header" @is_judge="is_judge"></HeaderTop>
      <!-- <Hezuo></Hezuo> -->
      <!-- 直播 -->
      <div class="center pc_center main">
        <div class="video_div flex_between">
          <!-- 视频区域 -->
          <div class="video_left video_border video_left_center">
            <div class="video_left_top flex_between">
              <div class="video_title flex_start">
                <!-- <i><img src="https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg" alt=""></i> -->
                <div class="title_name flex_between">
                  <div class="title_h5">{{ details.name }}</div>
                  <div class="flex_start title_tag">
                    <span class="flex_start">
                      <i>
                        <img src="@/assets/img/ren.png" alt>
                      </i>
                      麻醉·眼界直播中心
                    </span>
                    <span class="flex_start">
                      <i>
                        <img src="@/assets/img/time.png" alt>
                      </i>
                      开播时间：{{ details.start_time }}
                    </span>
                    <span class="flex_start">
                      <i>
                        <img src="@/assets/img/yan.png" alt>
                      </i>
                      {{ thousandBitSee }}人/次
                    </span>
                    <span class="flex_start">
                      <i>
                        <img src="@/assets/img/dianzan.png" alt>
                      </i>
                      点赞数：{{ thousandBitSeparator }}
                    </span>

                    <div class="label_li flex_center share_button">
                      <i><img src="@/assets/img/fenxiangP.png" alt=""></i>
                      分享
                      <div class="share_div">
                        <!-- <img src="@/assets/img/er.jpg" alt=""> -->
                        <div id="qrcode"></div>
                        <div class="flex_center wx_saosao">微信扫一扫</div>
                      </div>
                    </div>
                    <!-- <div class="label_li flex_center" @click.stop="is_directory = !is_directory">
                      <i><img src="@/assets/img/directoryT.png" alt=""></i>
                      节点目录
                    </div> -->

                  </div>
                </div>
              </div>
              <!-- <div class="focus flex_center" @click="maskShowc">
                <img src="@/assets/img/focus.png" alt>
                关注
              </div> -->
            </div>

            <div class="video_live flex_center">
              <!-- <div class="flex_center speed_div" @click.stop="is_directory = !is_directory">
                <i>
                  <img src="@/assets/img/directoryT.png" alt="">
                </i>
                节点目录
              </div> -->

              <!-- 欢迎标语 -->
              <div class="welcome">欢迎来到直播间</div>
              <!--<video id="myVideo" controls="controls" x5-playsinline="" webkit-playsinline playsinline-->
              <!--x-webkit-airplay="true"  x5-video-player-type="h5-page" x5-video-player-type="h5"  x5-video-orientation="portraint">-->
              <!--<source :src="video" type="video/mp4">-->
              <!--</video>-->
              <!-- <video id="myVideo" v-if="type==1&& show_tiem" 
              :poster="details.cover?details.cover:'@/assets/img/tool.jpg'"
              class="video-js hidden vjs-default-skin vjs-big-play-centered"
                controls preload="auto" :autoplay="is_ie" :src="video" data-setup="{}" name="media" webkit-playsinline
                playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true">
                <source :src="video" type="application/x-mpegURL">
                <source :src="video" type="video/ogg">
                <source :src="video" type="video/mp4">
                <source :src="video" type="video/webm">
                <source :src="video" type="video/flv">您的浏览器版本偏低，请升级最新版！！！
              </video> -->
              <video-player id="myVideo" v-if="type == 1 && show_tiem" class="video-player vjs-custom-skin"
                ref="videoPlayer" @timeupdate="onPlayerTimeupdate($event)" :playsinline="true" :options="playerOptions">
              </video-player>
              <!-- 节点播放目录 -->
              <div class="node_list" v-if="is_directory">
                <i class="shutDown flex_center" @click.stop="is_directory = false"><img src="@/assets/img/cuo.png"
                    alt=""></i>
                <div class="list_ul">
                  <div class="list_li " @click.stop="seePlay(liem)" :key="index"
                    :class="{ 'selected': liem.id == directory_index }" v-for="(liem, index) in see_arr">
                    <span class="clamp3">
                      {{ liem.content }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 直播banner -->
            <div class="video_banner flex_center" @click.stop="publicFun">
              <div class="swiper-container" v-if="details.mobile_image">
                <div class="swiper-wrapper">
                  <div class="swiper-slide flex_center" v-for="(liem, index) in details.mobile_image" :key="index">
                    <img :src="IMG_URL + liem" alt>
                  </div>
                </div>
              </div>
              <div class="announcement_bg" v-else>
                <img src="@/assets/img/announcement_bg.png" alt>
                <h4 id="msgT" class="count flex_center">直播已结束</h4>
              </div>
            </div>
            <div class="video_div video_head flex_between introduce_div">
              <div class="introduce_head flex_start">
                <div class="introduce_li flex_center" @click="head_index = 2" :class="{ 'selected': head_index == 2 }">
                  介绍
                </div>
                <div class="introduce_li flex_center" @click="head_index = 3" :class="{ 'selected': head_index == 3 }">
                  推荐
                </div>
                <div class="introduce_li flex_center" @click="head_index = 1" :class="{ 'selected': head_index == 1 }">
                  合作
                </div>
                <div class="introduce_li flex_center" @click="head_index = 4" :class="{ 'selected': head_index == 4 }">
                  直播总结
                </div>
              </div>

            </div>
          </div>
          <!-- 讨论区 -->
          <div class="video_right video_border">
            <div class="video_right_head flex_center">
              <div class="head_li flex_center" :class="{ 'selected': video_border_index == 1 }"
                @click.stop="video_border_index = 1">聊天区</div>
              <div class="head_li flex_center" :class="{ 'selected': video_border_index == 2 }"
                @click.stop="video_border_index = 2">精选</div>
            </div>
            <div class="discuss_ul" id="new_message" v-if="video_border_index == 1">
              <div class="discuss_li" v-for="liem, index in chatArr" :class="{ 'red': liem.member_id == 0 }"
                :key="index">
                <div class="chat_left">
                  <div class="discuss_li_head flex_between">
                    <div class="discuss_li_name flex_start">
                      <i class="portrait">
                        <img
                          :src="liem.image ? liem.image : 'https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg'"
                          alt>
                      </i>
                      <div class="name">{{ liem.name }}</div>
                    </div>
                    <div class="discuss_li_time">{{ liem.time }}</div>
                  </div>
                  <div class="discuss_li_center" v-if="liem.type == '1'" v-html="liem.center"></div>
                  <div class="discuss_li_center li_r_img" v-if="liem.type == '2'">
                    <img :src="liem.center + '?x-oss-process=image/resize,m_lfit,w_289'" alt>
                  </div>
                </div>
                <!-- <div v-if="liem.id == 0" class="chat_right">
                                    <div class="discuss_li_head flex_between">
                                        <div class="discuss_li_time">
                                            {{liem.time}}
                                        </div>
                                        <div class="discuss_li_name flex_end">
                                            <div class="name">{{liem.name}}</div>
                                            <i class="portrait">
                                                <img src="https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg"
                                                    alt="">
                                            </i>
                                        </div>
                                    </div>
                                    <div class="discuss_li_center" v-html="liem.center">
                                    </div>
                </div>-->
              </div>
            </div>
            <div class="discuss_ul select_text" v-if="video_border_index == 2">
              <!-- <h4 class="discuss_title">精品留言</h4> -->
              <div class="discuss_center">
                <div class="mess_recomm_li" v-for="(liem, index) in recomm_ul" :key="index">
                  <h6 class="flex_start"><i><img :src="liem.image" alt=""></i>{{ liem.name }}</h6>
                  <div class="mess_recomm_li_cetnter" v-if="liem.type == 1" v-html="liem.center"></div>
                  <div class="mess_recomm_li_cetnter mess_recomm_img" v-if="liem.type == 2">
                    <img :src="liem.center" alt="">
                  </div>
                </div>
              </div>
              <!-- <h4 class="discuss_title heng">提问</h4> -->
              <div class="discuss_center discuss_center_text" v-html="details.live_date"></div>
            </div>
            <!-- 发送消息区 -->
            <div class="Send">
              <div class="content">
                <div class="tools-box">
                  <div class="operator-box-btn">
                    <div class="submit">
                      <input class="text" placeholder="请输入...">
                      <div class="submit-btn">
                        <input type="button" @click="out" value="发送">
                      </div>
                    </div>
                    <div class="chat_bottom">
                      <div class="chat_right">
                        <span class="face-icon flex_center" style="margin: 0 10px;">
                          <img src="@/assets/img/smiling.png" alt>
                        </span>
                        <i class="inp_img_box">
                          <input type="file" style="width: 20px" class="inp_img" @change="handleChange" id="imgInp"
                            ref="inputer" multiple accept="image/*">
                          <img src="@/assets/img/tupian.png" alt id="tupian">
                        </i>
                        <i id="inputBin" @click="goods" @mousedown.stop="giveFun"
                          :class="{ 'giveLike': is_give == true }">
                          <img id="btn" src="@/assets/img/dianzan.png" alt>
                        </i>
                      </div>
                      <!-- <span>点赞数：{{thousandBitSeparator}}</span> -->
                      <!-- <span>{{input_value.length}}/100</span> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 用户进入提示 -->
            <div class="user_enter">
              <div class="user_enter_li flex_center" :style="{ color: color_arr[index < 5 ? index : index % 5] }"
                v-for="(liem, index) in user_enterArr" :key="index">
                <i class="user_enter_portrait flex_center" :style="{ backgroundImage: 'url(' + liem.image + ')' }"></i>
                {{ liem.text }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="video_div flex_between introduce_div main">
        <!-- 直播介绍 -->
        <div class="video_left video_border introduce">
          <!-- 
                    <div class="min_img2" v-if="details.image">
                        <img :src="IMG_URL + details.image" alt="">
          </div>-->

          <div class="introduce_list" v-if="head_index == 1">
            <div v-html="details.cooperation"></div>
            <div v-if="!details.cooperation" class="claloadding">
              <div>
                <img src="@/assets/img/kkry_pc.gif" alt="">
              </div>
              <div>空空如也</div>
            </div>
          </div>
          <div class="introduce_list" v-if="head_index == 2">
            <div v-html="details.content"></div>
            <div v-if="!details.content" class="claloadding">
              <div>
                <img src="@/assets/img/kkry_pc.gif" alt="">
              </div>
              <div>空空如也</div>
            </div>

          </div>
          <div class="introduce_list" v-if="head_index == 4">
            <div v-html="details.message ? details.message : zongmessage">
            </div>
            <div v-if="!details.message" class="claloadding">
              <div>
                <img src="@/assets/img/kkry_pc.gif" alt="">
              </div>
              <div>空空如也</div>
            </div>
          </div>
          <!-- <div class="introduce_list" v-if="head_index == 2" v-html="details.live_date">
          </div>-->
          <div class="recommended_list flex_start video_ul" v-if="head_index == 3">
            <div class="recommended_li video_li flex_center" v-for="liem, index in recommendArr" @click="linkPage(liem)"
              :key="index">
              <!-- <div class="recommended_li_img flex_center">
                                <img v-if="liem.cover" :src="IMG_URL+liem.cover" alt="">
                                <img v-else src="@/assets/img/tool.jpg" alt="">
                            </div>
                            <div class="recommended_text flex_between">
                                <div class="li_title">{{liem.name}}</div>
                                <div class="li_time flex_start">
                                    <i><img src="@/assets/img/time.png" alt=""></i>
                                    开播时间：{{liem.start_time}}
                                </div>
              </div>-->
              <div class="recommended_li_img flex_center">
                <img v-if="liem.cover" :src="liem.cover" alt>
                <img v-else src="@/assets/img/tool.jpg" alt>
              </div>
              <div class="video_head flex_between">
                <div class="video_li_title">
                  <div class="title">{{ liem.name }}</div>
                </div>
                <!-- <div class="video_time flex_start">
                                    <img class="video_time_img" src="@/assets/img/video_icon.png" alt="">
                                    <span>直播时间：{{liem.start_time}} {{liem.time}}</span>
                </div>-->
              </div>
              <!-- <div class="video_center ">
                                <div class="video_name">
                                    {{liem.doctor}}
                                </div>
                                <div class="tag_title flex_start">
                                    <span>{{liem.position}}</span>
                                    <span>{{liem.hospital}}</span>
                                </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>

      <!-- 尾部 -->
      <Footer></Footer>
    </div>
    <div class="mask" v-if="maskShow">
      <img src="@/assets/img/cuo.png" alt class="mask_icon" @click="maskShowc">
      <div class="er_img">
        <img src="@/assets/img/er.jpg" alt>
        <p>使用微信扫码关注</p>
      </div>
    </div>
  </div>
</template>

<script>
import Hezuo from '@/components/tool/hezuo.vue'
import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
import Footer from "@/components/assembly/Footer.vue"; //尾部模块
import { AnalyticEmotion, Hashtable } from "@/assets/js/pcsinaFaceAndEffec.js";
import MobileDetect from "@/assets/js/mobile-detect.js";
import "@/assets/node_modules/tim-js-sdk/tim-js.js";
import "@/assets/node_modules/cos-js-sdk-v5/dist/cos-js-sdk-v5.min.js";
import "@/assets/js/pcmain.js";
import QRCode from 'qrcodejs2'

import "@/assets/css/video-js.min.css";
import "@/assets/css/header.css";
import "@/assets/css/main.css";
import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/pcsinaFaceAndEffec.css";
import "@/assets/css/pcmain.css";
var test2, test1, test3, iCount;



export default {
  name: "pc_record",
  data() {
    return {
      IMG_URL: this.$IMG_URL,
      LIVE_URL: this.$LIVE_URL, //直播前缀
      IM_URL: this.$IM_URL,
      is_loading: false,

      video_border_index: 1, //聊天室切换index
      head_index: 2,
      user: {}, //用户数据
      chatConter: "", //聊天内容

      chatArr: [], //聊天内容
      page: 1,
      power: 0,//房间类型
      id: "123", //直播房间id
      record_url: "", //视频路径
      recomm_ul: [],//精品留言

      groupid: "", //聊天室组
      sign: "", //userSign签名
      details: {}, //详情
      recommendArr: [], //推荐直播
      maskShow: false, //是否显示遮罩
      goodsNum: 0, //点赞数
      position: 0,
      screenWidth: document.body.clientWidth,
      timer: false,
      photo: "", //上传图片
      maxtime: 0,
      show_tiem: false, //倒计时和视频显示切换
      msg: "", //倒计时
      d: -1, //天
      h: -1, //小时
      m: -1, //分
      s: -1, //秒
      type: Number,
      open: Number,
      video: "",
      start_time: "",
      time: "",
      video_bott: true,
      input_value: "",
      href: '',//跳转地址

      is_ie: false, //是否是ie浏览器
      is_give: false, //点赞效果
      // 直播总结
      zongmessage: '<div style="text-align: center;width:100%;color:#666">暂无总结</div>',
      websock: null,
      token: null, //socket token
      sever: null, //socket地址
      startTimeNum: 0, //进入直播间时间挫
      startTimeNumS: 0,
      user_enterArr: [], //用户信息
      color_arr: ["#FFC903", "#FA3131", "#76FF15", "#1FFFCB", "#E539E8"], //用户颜色
      isFun: true,


      // 视频播放
      playerOptions: {
        playbackRates: [0.75, 1, 1.25, 1.5, 2], //可选择的播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          //   {
          //     type : "",
          //     src : 'http://www.html5videoplayer.net/videos/madagascar3.mp4'//url地址
          // } 
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,//当前时间和持续时间的分隔符
          durationDisplay: true,//显示持续时间
          remainingTimeDisplay: false,//是否显示剩余时间功能
          fullscreenToggle: true, //全屏按钮
          playbackRateMenuButton: true,
        }
      },
      // 目录
      is_directory: false,
      directory_index: 1,
      see_arr: [],//节点列表
      // seo
      keywords: "",
    };
  },
  metaInfo() {
    return {
      meta: [
        { name: "keywords", content: this.details.seo },
      ],
    };
  },
  computed: {
    thousandBitSeparator: function () {
      if (!this.goodsNum) return 0;
      let num = this.goodsNum;
      num = num.toString().split("."); // 分隔小数点
      var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
      var res = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        if (i % 3 === 0 && i !== 0) {
          res.push(","); // 添加分隔符
        }
        res.push(arr[i]);
      }
      res.reverse(); // 再次倒序成为正确的顺序
      if (num[1]) {
        // 如果有小数的话添加小数部分
        res = res.join("").concat("." + num[1]);
      } else {
        res = res.join("");
      }
      return res;
    },
    thousandBitSee: function () {
      //点赞数
      if (!this.details.see) return 0;
      let num = this.details.see;

      num = num.toString().split("."); // 分隔小数点
      var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
      var res = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        if (i % 3 === 0 && i !== 0) {
          res.push(","); // 添加分隔符
        }
        res.push(arr[i]);
      }
      res.reverse(); // 再次倒序成为正确的顺序
      if (num[1]) {
        // 如果有小数的话添加小数部分
        res = res.join("").concat("." + num[1]);
      } else {
        res = res.join("");
      }
      return res;
    }
  },
  components: {
    HeaderTop,
    Footer,
    Hezuo
  },
  watch: {

  },
  methods: {
    // seo 
    getSeo() {
      this.$get("seo").then((res) => {
        if (res.code == 200) {
          this.keywords = res.data[3];

        }
      });

    },
    onPlayerTimeupdate(player) {//记录当前播放时间
      if (player.isFullscreen_) {
        $('.vjs-icon-custombutton').remove();
      } else {
        this.getList();
      }
      if ($('.vjs-icon-buttom').length <= 0) {
        localStorage.setItem('video' + this.id, player.cache_.currentTime)
      }
    },
    seePlay(liem) {
      this.directory_index = liem.id;
      this.formatSeconds(liem.time);
      this.$refs.videoPlayer.player.currentTime(this.formatSeconds(liem.time));
      this.is_directory = false;
    },
    getList() {
      let that = this;

      if (that.see_arr.length > 0 && $('.vjs-icon-custombutton').length <= 0) {
        $('.vjs-control-bar').append('<button class="vjs-icon-custombutton flex_center">看点</button>');
        $('.vjs-icon-custombutton').on('click', function () {
          that.is_directory = !that.is_directory;
        });
      }

    },
    // video添加目录图标
    playerFun() {
      let that = this;
      if ($('.vjs-icon-custombutton').length > 0) {
        $('.vjs-icon-custombutton').remove();
      }
      if ($('.vjs-icon-buttom').length > 0) {
        $('.vjs-icon-buttom').remove();
      }
      // 判断有没有历史记录
      if (localStorage.getItem('video' + this.id)) {
        $('.vjs-control-bar').append('<button class="vjs-icon-buttom flex_center">点击回到上次播放 <span class="escFun"></span></button>');
        $('.vjs-icon-buttom').on('click', function () {
          that.$refs.videoPlayer.player.currentTime(localStorage.getItem('video' + that.id));
          $('.vjs-icon-buttom').remove();
        });
        $('.escFun').on('click', function () {
          $('.vjs-icon-buttom').remove();
        });
        setTimeout(() => {
          $('.vjs-icon-buttom').remove();
        }, 10000)
      }
      //获取
      this.$post("record_see", {
        live_id: this.id,
      }).then(e => {
        that.see_arr = e.data;
        that.getList();
      });

    },
    QRcodeFun() {//生成二维码
      let str = 'http://mzzb.anesthesiavision.cn'
      var qrcode = new QRCode(document.getElementById("qrcode"), {
        text: `${str}/#/min_record?id=${this.id}&url=${this.record_url}&power=${this.power}`,
        width: 150,
        height: 150,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.L
      });
    },
    publicFun() {//公共跳转地址
      if (this.href && this.href !== '') {
        location.href = this.href;
      }
    },
    modelsFun() {
      //记录机型
      var device_type = navigator.userAgent; //获取userAgent信息
      var md = new MobileDetect(device_type); //实例化mobile-detect
      var os = md.os(); //获取系统
      var model = "";
      if (os == "iOS") {
        //ios系统的处理
        os = md.os() + md.version("iPhone");
        model = md.mobile();
      } else if (os == "AndroidOS") {
        //Android系统的处理
        os = md.os() + md.version("Android");
      }
      let end_time = new Date().getTime();
      let that = this;
      this.$post("census", {
        url: "pc_record?id=" + this.id,
        type: JSON.stringify(md),
        member_id: this.user.id,
        time: end_time - this.startTimeNum,
        times: this.startTimeNumS,
      }).then(eve => {
        that.startTimeNum = end_time;
      });
    },
    giveFun() {
      this.is_give = true;
      let that = this;
      setTimeout(() => {
        that.is_give = false;
      }, 100);
    },
    judgeFun(liem) {//判断登录
      if (liem.power == 0) {
        return true
      }
      if (!this.USER() || this.USER() == {}) {
        layer.open({
          content: "请先登录账号",
          time: true,
          skin: "msg"
        });
        setTimeout(() => {
          this.$refs.header.registered(1);
        }, 1000)

        return false;
      }
      if ((this.USER().plus < 2 && liem.power == 2) || (this.USER().plus == 0 && liem.power == 1)) {
        layer.open({
          content: "权限不足，请联系管理员！",
          time: true,
          skin: "msg"
        });
        return false
      }
      return true;
    },
    //推荐跳转
    linkPage: function (i) {
      if (!this.judgeFun(i)) {
        return false;
      }
      this.$router.replace({ query: { id: i.id, url: i.live_url, power: i.power } });
      // this.$router.go(0)
      window.location.reload()
    },
    getRecommended: function () {
      //获取推荐
      let that = this;
      this.$get("live_recommend", { type: 1 }).then(eve => {
        that.recommendArr = eve.data;
      });
    },
    swiperFun() {
      new Swiper(".swiper-container", {
        autoplay: 2000 //可选选项，自动滑动
      });
    },
    is_judge() {//判断登录
      let that = this;
      if (!this.isFun) {
        return false;
      }
      this.isFun = false;
      if (!this.USER() || this.USER() == {}) {
        that.$get('username', {}).then(res => {
          that.user = res.data;
          that.funFun();
        })
      } else {
        that.user = this.USER();
        that.funFun();
      }

    },
    funFun() {//执行方法
      let that = this;
      if (this.power > 0) {
        if (!this.USER() || this.USER() == {}) {
          layer.open({
            content: "请先登录账号",
            time: true,
            skin: "msg"
          });
          setTimeout(() => {
            this.$refs.header.registered(1);
            this.$router.replace('/index');
          }, 1000)
        }
        if ((this.USER().plus < 2 && this.power == 2) || (this.USER().plus == 0 && this.power == 1)) {
          layer.open({
            content: "权限不足，请联系管理员！",
            time: true,
            skin: "msg"
          });
          setTimeout(() => {

            this.$router.replace('/index');
          }, 1000)
        }

      }
      this.page = 1;
      that.$nextTick(() => {
        that.getmessage();
        that.request();
        that.getRecommended();
      });
      setTimeout(() => {
        that.isFun = true;
      }, 500)
    },
    request() {
      //获取直播信息
      let that = this;
      this.$post("live_view", { live_id: this.id }).then(eve => {
        that.is_loading = true;
        if (eve.data.mobile_image) {
          eve.data.mobile_image = eve.data.mobile_image.split(",");
          setTimeout(() => {
            that.swiperFun();
          }, 5000);
        }
        that.details = eve.data;
        that.playerOptions.sources = [{
          type: "",
          src: that.record_url
        }];
        that.playerOptions.poster = that.details.cover ? that.details.cover : '@/assets/img/tool.jpg'

        setTimeout(() => {
          that.playerFun();
        }, 1000)


        that.goodsNum = eve.data.goods;
        that.groupid = eve.data.chatroomId;
        that.video = eve.data.record_url;

        that.start_time = eve.data.start_time;
        that.time = eve.data.time;
        that.maxtime = eve.data.date;
        that.open = eve.data.open;
        that.type = eve.data.type;
        that.addRegister();
        document.title = eve.data.name;
        iCount = setInterval(function () {
          that.timefc();
          //  
          if (that.d == 0 && that.h == 0 && that.m == 0 && that.s == 0) {
            clearInterval(iCount);
            return false;
          }
        }, 1000);
      });
    },
    addRegister() {
      //加入聊天室
      let that = this;
      $.ajax({
        type: "post",
        url: this.IM_URL + "register",
        data: {
          chat_id: this.details.chat_id,
          nickname: this.user.name,
          member_id: this.user.id,
        },
        success: function (ret) {
          //成功的回调函数

          that.getToken();
        },
        error: function (e) {

        }
      });
    },
    joinFun() {
      //新用户入群
      let that = this;
      $.ajax({
        type: "post",
        url: this.IM_URL + "user/joinGroup",
        data: {
          groupid: this.details.chat_id,
          member_id: this.USER().id,
          token: that.token
        },
        success: function (eve) {
          var joinNotify = {
            type: "joinNotify",
            groupid: that.details.chat_id,
            token: that.token
          };
          that.websocketsend(JSON.stringify(joinNotify));
        }
      });
    },
    getToken() {
      //获取token
      let that = this;
      $.ajax({
        type: "post",
        url: this.IM_URL + "login",
        data: {
          chat_id: this.details.chat_id,
          member_id: this.user.id,
          nickname: this.user.name,
        },
        success: function (ret) {
          //成功的回调函数

          that.token = ret.data.token;
          that.sever = ret.data.sever;
          that.user = ret.data.user;
          that.initWebSocket();
          if (ret.code == 200) {
            setTimeout(() => {
              that.joinFun();
            }, 500);
          }
        },
        error: function (e) {

          that.initWebSocket();
        }
      });
    },
    // 倒计时
    timefc: function () {
      //获取当前时间
      var date = new Date();
      var now = date.getTime();
      //设置截止时间
      var str = this.maxtime;
      var endDate = new Date(str);
      var end = endDate.getTime();
      //时间差
      var leftTime = end - now;
      //定义变量 d,h,m,s保存倒计时的时间
      var d, h, m, s;
      if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        m = Math.floor((leftTime / 1000 / 60) % 60);
        s = Math.floor((leftTime / 1000) % 60);
      }
      this.d = d;
      this.h = h;
      this.m = m;
      this.s = s;

      //type  0直播 1录播   open 0开启1关闭
      if (
        this.open == 1 &&
        this.type == 0 &&
        this.d != undefined &&
        this.h != undefined &&
        this.m != undefined &&
        this.s != undefined
      ) {
        this.video_bott = false;
        // this.msg = '距' + this.start_time + this.time + '还有' + d + '天' + h + '时' + m + '分' + s + '秒';
        $("#msgT").html(
          "距" +
          this.start_time +
          this.time +
          "还有" +
          d +
          "天" +
          h +
          "时" +
          m +
          "分" +
          s +
          "秒"
        );

      } else if (
        this.open == 1 &&
        this.type == 0 &&
        this.d == undefined &&
        this.h == undefined &&
        this.m == undefined &&
        this.s == undefined
      ) {

        this.d = 0;
        this.h = 0;
        this.m = 0;
        this.s = 0;
      } else if (this.open == 0 && this.type == 0) {

        this.d = 0;
        this.h = 0;
        this.m = 0;
        this.s = 0;
      } else if (this.type == 1) {

        this.d = 0;
        this.h = 0;
        this.m = 0;
        this.s = 0;
      }
    },
    out: function () {
      //发送
      //发送
      var inputText = $(".text").val();
      if (!inputText) {
        layer.open({
          content: "请输入内容",
          time: true,
          skin: "msg"
        });
        return false;
      }
      let that = this;
      this.$post("forbidden", { member_id: this.user.id, chat_id: this.details.chat_id }).then(e => {
        if (e.data == 1) {
          layer.open({
            content: "你已被禁言",
            time: true,
            skin: "msg"
          });
        } else if (e.data == 3) {
          layer.open({
            content: "当前直播未开启留言功能",
            time: true,
            skin: "msg"
          });
        } else {
          $('#info-show ul').append(that.send(AnalyticEmotion(inputText)))
        }
      })
    },
    is_userFun() {
      // if (!this.USER() || this.USER() == {}) {
      if (this.details.is_message == 0 && (this.user.mobile == '' || !this.user.mobile)) {
        layer.open({
          content: "请先登录账号",
          time: true,
          skin: "msg"
        });
        this.websock.close();
        setTimeout(() => {
          this.$refs.header.registered(1);
        }, 1000);
        return false;
      }
      return true;
    },
    send: function (content) {
      //发送消息
      if (!this.is_userFun()) {
        return false;
      }
      this.websocketsend(
        JSON.stringify({
          data: {
            mine: {
              name: this.user.name,
              image: this.user.image,
              id: this.user.id,
              mine: true,
              content: content
            },
            to: {
              id: this.id,
              groupname: this.details.name,
              avatar: this.IMG_URL + this.details.cover,
              name: this.details.name,
              types: 1,
              type: "group"
            },
            token: this.token
          },
          type: "chatMessage" //随便定义，用于在服务端区分消息类型
        })
      );
      var myDate = new Date();
      let getMonth = (myDate.getMonth() + 1) >= 10 ? myDate.getMonth() + 1 : '0' + (myDate.getMonth() + 1);
      let getDate = myDate.getDate() >= 10 ? myDate.getDate() : '0' + myDate.getDate();
      let getHours = myDate.getHours() >= 10 ? myDate.getHours() : '0' + myDate.getHours();
      let getMinutes = myDate.getMinutes() >= 10 ? myDate.getMinutes() : '0' + myDate.getMinutes();
      let time_num = getMonth + '-' + getDate + ' ' + getHours + ':' + getMinutes
      this.chatArr.unshift({
        id: 0,
        name: this.user.name,
        type: 1,
        image: this.user.image,
        center: content,
        time: time_num
      });
      this.input_value = "";
      $(".text").val('');
      this.backTop();
    },
    // 页面回到顶部
    backTop: function () {
      document.getElementById('new_message').scrollTop = 0;
      const that = this;
      let timer = setInterval(function () {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (document.documentElement.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },

    //上传图片
    handleChange: function (e) {
      if (!this.is_userFun()) {
        return false;
      }
      let _this = this;
      let images = "";
      var reader = new FormData();

      reader.append("file", e.target.files[0]);

      //发送图片消息
      $.ajax({
        type: "POST", //提交方式
        url: this.$URL + "upload", //路径
        data: reader,
        processData: false,
        contentType: false,
        success: function (result) {
          //返回数据根据结果进行相应的处理
          //  
          _this.websocketsend(
            JSON.stringify({
              data: {
                mine: {
                  name: _this.user.name,
                  image: _this.user.image,
                  id: _this.user.id,
                  mine: true,
                  content: result.data
                },
                to: {
                  id: _this.id,
                  groupname: _this.details.name,
                  avatar: _this.IMG_URL + _this.details.cover,
                  name: _this.details.name,
                  types: 2,
                  type: "group"
                },
                token: _this.token
              },
              type: "chatMessage" //随便定义，用于在服务端区分消息类型
            })
          );
          var myDate = new Date();
          let getMonth = (myDate.getMonth() + 1) >= 10 ? myDate.getMonth() + 1 : '0' + (myDate.getMonth() + 1);
          let getDate = myDate.getDate() >= 10 ? myDate.getDate() : '0' + myDate.getDate();
          let getHours = myDate.getHours() >= 10 ? myDate.getHours() : '0' + myDate.getHours();
          let getMinutes = myDate.getMinutes() >= 10 ? myDate.getMinutes() : '0' + myDate.getMinutes();
          let time_num = getMonth + '-' + getDate + ' ' + getHours + ':' + getMinutes
          _this.chatArr.unshift({
            id: 0,
            name: _this.user.name,
            image: _this.user.image,
            type: 2,
            center: result.data,
            time: time_num
          });
        }
      });
      this.backTop();
    },
    //获取历史聊天记录
    getmessage: function () {
      let that = this;
      if (this.page == 1) {
        that.chatArr = [];
      }
      this.$post("message", {
        live_id: this.id,
        page: that.page,
        limit: 10
      }).then(eve => {
        that.chatArr = that.chatArr.concat(eve.data);
        that.$nextTick(() => {
          that.addImg();
        });
      });
    },
    //监听聊天页面滚动
    handleScroll: function (e) {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight >= scrollHeight - 20) {
        this.page++;
        this.getmessage();
        //写后台加载数据的函数
        //          	 
        // alert("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
      }
    },
    goods: function () {
      //点赞
      let that = this;
      this.$get("goods", {
        live_id: this.id
      }).then(eve => {
        that.goodsNum = eve.data;
      });
    },
    //关注- 遮罩
    maskShowc: function () {
      this.maskShow = !this.maskShow;

    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    refresh() {
      //刷新数量
      let that = this;
      this.$post("num", { live_id: this.id }).then(e => {
        that.goodsNum = e.data.data ? e.data.data : that.goodsNum;
        that.details.see = e.data.see ? e.data.see : that.details.see;
        that.show_tiem = e.data.open;
        that.details.live_date = e.data.date ? e.data.date : that.details.live_date;
      });

      this.$post("mess_recomm", { live_id: this.id, page: 1, limit: 999999 }).then(e => {
        that.recomm_ul = e.data;
      })
    },
    getChat() {
      let that = this;
      this.$post("message", {
        live_id: this.id,
        page: 1,
        limit: this.page * 10
      }).then(e => {
        that.chatArr = e.data;
      });
    },
    addImg() {
      $(".li_r_img img").on("click", function () {

        $(this).ImgZoomIn("");
      });
    },
    initWebSocket() {
      //初始化weosocket
      const wsuri = this.sever;
      this.websock = new WebSocket(wsuri + "?token=" + this.token);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      //连接建立之后执行send方法发送数据
      let that = this;
      test1 = setInterval(function () {
        that.websocketsend(JSON.stringify({ type: "ping" }));
      }, 1000 * 10);

    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();

    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);


      let that = this;
      if (redata.type == "joinNotify") {
        let data = redata.data;//{"system":true,"id":80,"type":"group","content":"湖南省用户15927276570加入了群聊，欢迎下新人吧～"}
        if (that.user_enterArr.length < 30) {
          that.user_enterArr.push({
            text: data.content,
            image: data.image,
          })
        } else {
          that.user_enterArr = [];
        }
      }
      if (redata.live_id == this.id) {
        this.chatArr = [
          {
            member_id: redata.fromid,
            center: redata.content,
            time: redata.timestamp,
            name: redata.name,
            type: redata.types,
            image: redata.image,
            id: redata.fromid == this.user.id ? 0 : 1
          }
        ].concat(this.chatArr);
      }
      that.$nextTick(() => {
        that.addImg();
      });
    },
    websocketsend(Data) {
      //数据发送

      this.websock.send(Data);
      let that = this;
      that.$nextTick(() => {
        that.addImg();
      });
    },
    websocketclose(e) {
      //关闭

    },
  },
  created() {
    this.startTimeNum = new Date().getTime(); //获取进入直播时间
    this.startTimeNumS = new Date().getTime();
    this.getSeo()
  },
  activated() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.startTimeNum = new Date().getTime();//获取进入直播时间
    this.startTimeNumS = new Date().getTime();
    this.getSeo()
    let that = this;
    this.id = this.$route.query.id;
    this.record_url = this.$route.query.url;
    this.power = this.$route.query.power;
    this.is_judge()
    this.QRcodeFun();
    $(".face-icon").SinaEmotion($(".text"));
    $(".face-icon").click(function () {
      $("#emotions").css({ left: "66%", width: "336px", "z-index": "999" });
    });
    document.onkeydown = function (event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        // enter 键
        //要做的事情
        that.out();
        // alert("按 Enter");
      }
    };
    window.addEventListener("scroll", this.handleScroll, true);
    this.refresh();
    that.modelsFun()
    test2 = setInterval(function () {
      that.refresh();
      that.modelsFun();
    }, 10000);
    test3 = setInterval(function () {
      that.getChat();
      that.addImg();
    }, 20000);
    if (this._isMobile()) {
      // alert("手机端");
      this.$router.replace({
        path: "min_record",
        query: { id: this.id, url: this.record_url }
      });
    } else {
      // alert("pc端");
      // this.$router.replace({path: 'pc_record',query:{id:this.id,url:this.record_url}});
    }

    //百度统计
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?8379155748b2097b694a2dcc7678ee2e";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    // 进入房间欢迎语动画
    setTimeout(() => {
      $(".welcome").animate({ top: "20px", opacity: "1" }, 1000, function () {
        let data = $(this);
        setTimeout(function () {
          data.animate({ opacity: "0" }, 1000);
        }, 1000);
      });
    }, 1000);
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    let that = this;
    this.id = this.$route.query.id;
    this.record_url = this.$route.query.url;
    this.power = this.$route.query.power;
    this.is_judge()
    this.QRcodeFun();
    $(".face-icon").SinaEmotion($(".text"));
    $(".face-icon").click(function () {
      $("#emotions").css({ left: "66%", width: "336px", "z-index": "999" });
    });
    document.onkeydown = function (event) {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (e && e.keyCode == 13) {
        // enter 键
        //要做的事情
        that.out();
        // alert("按 Enter");
      }
    };
    window.addEventListener("scroll", this.handleScroll, true);
    this.refresh();
    that.modelsFun()
    test2 = setInterval(function () {
      that.refresh();
      that.modelsFun();
    }, 10000);
    test3 = setInterval(function () {
      that.getChat();
      that.addImg();
    }, 20000);
    if (this._isMobile()) {
      // alert("手机端");
      this.$router.replace({
        path: "min_record",
        query: { id: this.id, url: this.record_url }
      });
    } else {
      // alert("pc端");
      // this.$router.replace({path: 'pc_record',query:{id:this.id,url:this.record_url}});
    }

    //百度统计
    var _hmt = _hmt || [];
    (function () {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?8379155748b2097b694a2dcc7678ee2e";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
    // 进入房间欢迎语动画
    setTimeout(() => {
      $(".welcome").animate({ top: "20px", opacity: "1" }, 1000, function () {
        let data = $(this);
        setTimeout(function () {
          data.animate({ opacity: "0" }, 1000);
        }, 1000);
      });
    }, 1000);
  },
  destroyed() {
    // this.modelsFun();

    this.websock.close() //离开路由之后断开websocket连接
    clearInterval(test2)
    clearInterval(test1)
    clearInterval(test3)
    clearInterval(iCount)

  },
  beforeDestroy: function () {
    this.websock.close() //离开路由之后断开websocket连接
    clearInterval(test2)
    clearInterval(test1)
    clearInterval(test3)
    clearInterval(iCount)

  }
};
</script>
<style>
.discuss_center_text img {
  width: 100%;
}

.vjs-modal-dialog-content,
.video-js .vjs-modal-dialog {
  display: none !important;
}

/* video 目录播放按钮 */
.video-js .vjs-control-bar .vjs-icon-custombutton {
  font-weight: normal;
  font-style: normal;

  -webkit-box-ordinal-group: 8;
  -ms-flex-order: 5;
  order: 5;
  cursor: pointer;
  position: relative;
  min-width: 2.2rem;
  white-space: nowrap;
}

.claloadding {
  width: 100%;
  height: 50vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

.video-js .vjs-control-bar .vjs-icon-buttom {
  -webkit-box-ordinal-group: 8;
  -ms-flex-order: 7;
  order: 7;
  position: absolute;
  right: 2rem;
  top: 0;
  font-size: 1.2rem;
  color: #fff;
  transform: translateY(-100%);
  background: #3b95e8;
  border-radius: 0.3rem;
  height: 2.6rem;
  padding: 0.8rem;
  cursor: pointer;
}

.video-js .vjs-control-bar .vjs-icon-buttom span.escFun {
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  width: 2rem;
  height: 2rem;
  background: url("../../assets/img/cuo.png") no-repeat;
  background-size: 80%;
  background-position: center;
  background-color: #40b417;
  border-radius: 50%;
  cursor: pointer;
}

.vjs-custom-skin>.video-js .vjs-time-tooltip {
  width: auto !important;
}
</style>
<style scoped>
html,
body {
  overflow-x: auto;
}

#index {
  background: #f6f5fa;
  overflow: auto;
  min-width: 1282px;
}

.layui-m-layershade {
  background-color: rgba(0, 0, 0, 0.1);
  pointer-events: auto;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.showtime {
  background-color: #ffffff;
  padding: 0.1rem 0;
}

.mask .mask_icon {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 100px;
  top: 100px;
}

.mask .er_img {
  display: block;
  width: 250px;
  height: 250px;
  top: 30%;
  left: 50%;
  margin-left: -125px;
  position: absolute;
}

html,
body {
  background: #f6f5fa;
  text-align: left;
}

.er_img>img {
  width: 100%;
}

.er_img>p {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  margin-top: 10px;
}

.pc_center {
  display: block;
  margin-top: 13px !important;
}

.min_center {
  display: none;
}

.main {
  max-width: 1282px;
  min-width: 865px;
  margin: 0 auto;
  width: 1282px;
  overflow: auto;
}

.video_border {
  border-radius: 8px;
  overflow: hidden;
}

/* 视频区*/
.video_div {
  /* padding-top: 8px; */
  align-items: flex-start;
  height: 800px;
}

.video_div .video_left {
  /* width: calc(100% - 347px); */
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.video_div .video_left .video_left_top {
  height: 80px;
  background: #fff;
  padding: 0 20px;
  z-index: 6;
}

.video_left_top .video_title {
  width: calc(100% - 80px);
  align-items: center;
}

.video_left_top .video_title>i {
  width: 53px;
  height: 53px;
  border-radius: 50%;
  overflow: hidden;
  background: #f7f7f7;
  margin-right: 12px;
}

.video_left_top .video_title>.title_name {
  flex-direction: column;
  align-items: flex-start;
  height: 50px;
}

.video_left_top .video_title>.title_name .title_h5 {
  font-size: 20px;
  line-height: 23px;
  color: #000;
  font-weight: bold;
}

.video_left_top .video_title>.title_name .title_tag span {
  margin-right: 34px;
  color: #666666;
  font-size: 13px;
  line-height: 1em;
  align-items: center;
}

.video_left_top .video_title>.title_name .title_tag span>i {
  width: 12px;
  margin-right: 5px;
}

.spinner-box {
  width: 100%;
  height: 100vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

.video_left_top .focus {
  width: 95px;
  height: 33px;
  border-radius: 10px;
  cursor: pointer;
  color: #fff;
  background: #f24d5b;
  font-size: 16px;
}

.video_left_top .focus>img {
  width: 16px;
  margin-right: 8px;
}

.video_live {
  width: 100%;
  height: calc(100% - 276px);
  background-color: #000000;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
  position: relative;
}

.video_live>video {
  width: 100%;
  height: 100%;
}

.video_live .count {
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  /* display: flex;
			justify-content: center;
			align-content: center; */
  color: red;
  font-weight: bold;
  height: calc(100%);
  background-color: rgba(0, 0, 0, 0.8);
  line-height: 684px;
  text-align: center;
  width: 100%;
  z-index: 99 !important;
}

.video_live>img {
  width: 100%;
}

.video_left_center.video_border.video_left {
  width: calc(100% - 350px);
  margin: 0;
}

/* 直播banner */
.video_banner {
  height: 112px;
  background-color: #b5a3aa;
  cursor: pointer;
}

.video_banner h4 {
  font-size: 30px;
  color: #fff;
}

.video_banner .swiper-container {
  width: 100%;
  height: 100%;
}

/* 直播切换 */
.video_head.video_div.introduce_div {
  height: 85px;
  background: #fff;
  align-items: center;
  padding: 0 26px;
}

/* 导论区 */
.video_div .video_right {
  width: 336px;
  height: 100%;
  background: #fff;
  position: relative;
}

.video_right_head {
  margin-bottom: 10px;
}

.video_right_head>.head_li {
  width: 50%;
  height: 49px;
  background: #dcdcdc;
  color: #fff;
  position: relative;
  font-size: 18px;
  cursor: pointer;
}

.video_right_head>.head_li::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  float: left;
  width: 0;
  height: 0;
  border-width: 8px;
  border-style: solid;
  border-color: #dcdcdc transparent transparent transparent;
}

.video_right_head>.head_li.selected {
  background: #f24d5b;
}

.video_right_head>.head_li.selected::after {
  border-color: #f24d5b transparent transparent transparent;
}

.video_div .video_right .discuss_ul {
  padding: 20px 15px;
  height: calc(100% - 198px);
  overflow-y: auto;
  /* -ms-overflow-style: none;
            scrollbar-width: none; */
  transition: all 0.5s ease;
}

.video_div .video_right .discuss_ul img {
  /* width: 100%; */
}

.video_div .video_right .discuss_ul::-webkit-scrollbar {
  /* display: none; */
  /* Chrome Safari */
}

.video_div .video_right .discuss_ul .discuss_li {
  margin-bottom: 20px;
}

.discuss_ul .discuss_li_head {
  height: 30px;
}

.discuss_li_head .discuss_li_name {
  width: calc(100% - 90px);
  align-items: center;
}

.discuss_li_name>.portrait {
  width: 30px;
  height: 30px;
  background: #f7f7f7;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 8px;
}

.discuss_li_name>.name {
  font-size: 14px;
  color: #3285d9;
  text-align: left;
}

.discuss_li_time {
  font-size: 14px;
  color: #999;
  max-width: 80px;
}

.discuss_li_center {
  text-align: left;
  font-size: 14px;
  color: #1a1a1a;
  margin-top: 8px;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.discuss_li .chat_right .discuss_li_center {
  text-align: right;
}

.discuss_li .chat_right .portrait {
  margin: 0 0 0 8px;
}

.discuss_li.red .name,
.discuss_li.red .discuss_li_center {
  color: #ff0000 !important;
  font-weight: bold;
}

.inputBox {
  height: 100px;
  border-top: 1px solid #e2e2e2;
  padding: 10px 9px 0 9px;
}

.inputBox .icon_div {
  height: 45px;
}

.inputBox .icon_div .icon_ul>i {
  width: 20px;
  margin: 0 10px;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.inp_img_box {
  cursor: pointer;
  position: relative;
}

.inp_img {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
}

.inputBox .icon_div>span {
  font-size: 13px;
  color: #999;
}

.input_div {
  height: 50%;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
}

.input_div>.textarea {
  height: 100%;
  border: 0;
  width: calc(100% - 50px);
  padding: 6px 12px;
  font-size: 12px;
  overflow: hidden;
  overflow-y: auto;
  color: #666;
  resize: none;
}

.input_div .enter_buttom {
  width: 52px;
  font-size: 14px;
  color: #fff;
  height: 100%;
  cursor: pointer;
  background: #f24c5a;
}

/* 直播介绍 */
.introduce_div {
  height: auto;
}

.introduce {
  /* background: #fff; */
}

.introduce .introduce_head {
  height: 60px;
  border-bottom: 1px solid #e2e2e2;
  padding: 0 40px;
  background: #fff;
  align-items: center;
}

.introduce_head .introduce_li {
  font-size: 18px;
  color: #777;
  margin-right: 31px;
  height: 100%;
  cursor: pointer;
  position: relative;
}

.introduce_head .introduce_li.selected {
  color: #000;
  font-weight: bold;
}

.introduce_head .introduce_li.selected::after {
  position: absolute;
  content: "";
  left: 50%;
  width: 100%;
  height: 3px;
  transform: translateX(-50%);
  bottom: 0;
  background: #f24c5a;
  border-radius: 2px;
}

.introduce_list {
  overflow-x: hidden;
  padding: 20px 0;
}

.introduce_list img {
  width: 100%;
}

#myVideo {
  width: 100%;
  height: 100%;
  background: #fff;
}

.myVideo .myVideo>div {
  width: 100%;
  height: 100%;
}

/* 点赞 */
#inputBin {
  height: 20px;
  width: 20px;
  padding: 0;
  background: 0;
  box-shadow: none;
  position: relative;
  margin: auto 10px;
  border-radius: 50%;
  cursor: pointer;
}

#inputBin>img {
  height: 100%;
  background: transparent !important;
  box-shadow: none !important;
  width: 100%;
  /* margin: 0 !important; */
  margin: auto 0;
}

#inputBin.giveLike {
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
}

.operator-box-btn>span {
  line-height: 20px;
}

#inputBin>i {
  width: 18px;
  height: 18px;
}

#content {
  width: 100%;
}

.min_img2>img {
  width: 100%;
  display: block;
  margin: 0 auto;
}

#roomVideo_html5_api {
  width: 100%;
  height: 100%;
}

.btnc {
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.1);
  position: absolute;
  margin: 0 auto;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnc .diamond {
  text-align: center;
  text-align: center;
  line-height: 100px;
  border-radius: 50%;

  /* background: white; */
}

.layui-m-layer1 .layui-m-layerchild {
  background-color: transparent;
}

.Send {
  height: 100px;
  width: 100%;
}

.submit {
  width: 100%;
  border: 1px solid rgba(226, 226, 226, 1);
  border-radius: 0.4rem;
  display: flex;
  margin: 10px;
}

.tools-box .operator-box-btn {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.submit>input {
  flex: 1;
}

.tools-box .submit-btn input {
  width: 100%;
  height: 100%;
  font-family: 微软雅黑;
  font-size: 1.4rem;
  color: #ffffff;
  cursor: pointer;
  border: none;
  outline: none;
  background-color: #f24d5b;
  border-radius: 0 0.4rem 0.4rem 0;
  padding: 10px 0;
}

.face-icon {
  float: left;
  margin-top: 0;
  margin-left: 5px;
  margin-right: 5px;
  font-family: 微软雅黑;
  font-size: 0;
  color: #9c6 !important;
  cursor: pointer;
}

/* 推荐 */

.video_ul {
  flex-wrap: wrap;
  align-items: flex-start;
  display: flex;
  width: calc(100% + 9px);

  overflow: auto;
  margin-top: 10px;
}

.video_ul .video_li {
  width: calc(33.3% - 16px);
  margin: 8px;
  cursor: pointer;
  border-radius: 10px;
  overflow: auto;
  background: #fff;
  transition: all 0.5s ease;
  position: relative;
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0);
}

.video_ul .video_li:hover {
  box-shadow: 7px 0 46px rgba(71, 71, 71, 0);
}

.video_ul .video_li .video_li_title {
  width: 100%;
  align-items: center;
}

.video_ul .video_li .video_li_title .title {
  max-width: calc(100% - 40px);
  margin: 0 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 20px;
  font-weight: bold;
}

.video_ul .video_li .video_li_title .tag {
  margin-left: 4px;
  width: 33px;
  height: 18px;
  border-radius: 4px;
  background: #ee8a60;
  color: #ffffff;
  font-size: 12px;
}

.video_ul .video_li .video_head {
  position: absolute;
  flex-direction: column;
  align-items: flex-start;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  line-height: 50px;
  height: 50px;
  color: #fff;
  /* border-bottom: 1px dashed #E4E4E4; */
}

.video_ul .video_li .video_head .video_time>.video_time_img {
  width: 22px;
  margin-right: 8px;
}

.video_ul .video_li .video_head .video_time>span {
  font-size: 14px;
  color: #818a92;
}

.video_center {
  align-items: center;
  height: calc(100% - 114px);
  padding: 20px 0;
}

.video_center>.touxiao {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 8px;
}

.video_center .video_name {
  font-size: 14px;
  color: #525963;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}

.video_center .tag_title {
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
}

.video_center .tag_title>span {
  font-size: 14px;
  color: #525963;
  margin-right: 10px;
  white-space: nowrap;
}

.roomVideo_bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-repeat: no-repeat;
  background-color: #000;
  background-size: 100% auto;
  background-position: center;
}

.video_bottom_banner {
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: center;
}

.chat_bottom {
  padding: 0 16px 0 0;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.chat_bottom .chat_right {
  display: flex;
  align-items: center;
}

.recommended_list .recommended_li {
  width: calc(33.3% - 16px);
  margin: 8px;
  height: 225px;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 20px rgba(71, 71, 71, 0.11);
  transition: all 0.5s ease;
  background-size: contain !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}

.recommended_list .recommended_li .recommended_li_img {
  height: 240px;
  overflow: hidden;
  border-radius: 12px;
  width: 100%;
}

.recommended_list .recommended_li .recommended_li_img img {
  border-radius: 12px;
}

.face-icon img {
  width: 20px;
}

.welcome {
  text-align: center;

  position: absolute;
  top: -20px;
  opacity: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 80%;
  min-width: 30%;
  min-height: 30px;
  padding: 10px 20px;
  font-size: 16px;
  color: #333;
  box-shadow: 2px 2px 14px rgba(247, 244, 248, 0.6);
  border-radius: 8px;
  background: #fff;
  z-index: 9999;
}

.user_enter {
  position: absolute;
  bottom: 120px;
  right: 0;
}

.user_enter .user_enter_li {
  font-size: 16px;
  color: #333;
  position: absolute;
  bottom: 0;
  opacity: 0;
  right: 0;
  white-space: nowrap;
  animation: myfirst 4s ease;
}

.user_enter .user_enter_li .user_enter_portrait {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  overflow: hidden;
  display: block;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-right: 10px;
}

@keyframes myfirst {
  0% {
    bottom: 0px;
    opacity: 0;
  }

  20% {
    bottom: 40px;
    opacity: 1;
  }

  100% {
    bottom: 160px;
    opacity: 0;
  }
}

.announcement_bg {
  position: relative;
  width: 100%;
}

.announcement_bg img {
  width: 100%;
}

#msgT {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  left: 50%;
  color: #000;
}

.recommended_list .recommended_li img {
  width: 100%;
}

.swiper-slide img {
  width: 100%;
}

.discuss_title {
  font-size: 22px;
  color: #1a1a1a;
  font-weight: bold;
  margin-bottom: 10px;
}

.discuss_title.heng {
  border-top: 0.005rem solid #e2e2e2;
  padding-top: 18px;
}

.discuss_center {
  margin-bottom: 16px;
}

.discuss_center img {
  max-width: 100%;
}

.discuss_center .mess_recomm_li {
  margin: 14px 0;
}

.discuss_center .mess_recomm_li>h6 {
  font-size: 14px;
  color: #3285d9;
}

.discuss_center .mess_recomm_li>h6>i {
  width: 30px;
  border-radius: 50%;
  overflow: hidden;
  height: 30px;
  margin-right: 6px;
}

.discuss_center .mess_recomm_li>.mess_recomm_li_cetnter {
  font-size: 14px;
  word-wrap: break-word;
  margin-top: 6px;
}

.mess_recomm_li_cetnter.mess_recomm_img img {
  width: 100%;
}

.label_li {
  font-size: 14px;
  color: #999;
  margin-left: 30px;
  line-height: 1em;
  cursor: pointer;
  position: relative;
}

.label_li>i {
  width: 15px;
  margin-right: 5px;
}

.label_li .share_div {
  position: absolute;
  bottom: 0;
  display: none;
  left: 50%;
  width: 150px;
  transform: translate(-50%, 110%);
  background: #fff;
  padding: 14px 14px 10px 14px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  z-index: 999;
}

.label_li .share_div::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-top: 10px transparent dashed;
  border-left: 10px transparent dashed;
  border-bottom: 10px transparent dashed;
  border-right: 10px #fff solid;
  transform: translate(-50%, -100%) rotate(90deg);
}

.label_li.share_button:hover .share_div {
  display: block;
}

.wx_saosao {
  margin-top: 6px;
  font-size: 14px;
  color: #858fa6;
}

/* 弹幕 */
.speed_div {
  position: absolute;
  right: 20px;
  top: 18px;
  z-index: 999;
  height: 30px;
  padding: 0 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 0 10px rgb(0, 0, 0, 0.1);
}

.speed_div i {
  width: 20px;
}

.speed_div .speed_vlaue {
  font-weight: bold;
}

/* 节点目录 */
.node_list {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  z-index: 999999;
}

.node_list .shutDown {
  width: 30px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.list_ul::-webkit-scrollbar {
  width: 0 !important;
}

.list_ul {
  margin: 40px auto;
  padding: 0 40px;
  width: calc(100% - 80px);
  height: calc(100% - 80px);
  overflow: auto;
  -ms-overflow-style: none;
  display: flex;
  align-content: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.list_ul .list_li {
  width: calc(25% - 40px);
  margin: 8px 10px;
  height: calc(33% - 30px);
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  color: #fff;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 18px;
  color: #fff;
  display: inline-flex;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.list_ul .list_li span {
  overflow: hidden;
  display: -webkit-inline-box;
  text-align: left;
}

.list_ul .list_li:hover {
  background: rgba(0, 0, 0, 0.8);
}

.list_ul .list_li.selected {
  color: #fc9b55;
}

.list_ul .list_li.selected::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #fc9b55;
}

.discuss_li_center {
  -webkit-user-select: text;
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
</style>


// WEBPACK FOOTER //
// src/components/pcVideo/pc_record.vue